<ng-container *ngIf="fund$ | async as fund">
  <terra-under-management-information class="container" />

  <mat-card class="container tabs-card">
    <nav class="tabs-navigation"
         mat-tab-nav-bar [tabPanel]="tabPanel" mat-stretch-tabs="false" mat-align-tabs="start">
      @for (tab of tabs; track tab.route)
      {
        @if(!tab.isHidden)
        {          
          <a mat-tab-link
             [routerLink]="tab.route"
             routerLinkActive #rla="routerLinkActive" [routerLinkActiveOptions]="{ exact: true }"
             [active]="rla.isActive">
            {{tab.label + (rla.isActive && tab.labelBadge !== undefined && tab.labelBadge !== null ? " (" + tab.labelBadge +")" : "")}}
          </a>
        }
      }
    </nav>
    <!-- Tabs content  -->
    <div class="tabs-card-inner">
      <mat-tab-nav-panel #tabPanel>
        <router-outlet (activate)="onActivateChild($event)" />
      </mat-tab-nav-panel>
    </div>

  </mat-card>
</ng-container>
